// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__1RDBR","mainContainer":"Layout_mainContainer__112YW","header":"Layout_header__14cTt"};